import { Injectable } from '@angular/core';
// @ts-ignore
import * as SgeCrypto from 'src/assets/lib/sge/sge-crypto';

@Injectable()
export class EnvironmentSgeUrlService {
  public sgeCrypto = SgeCrypto;
  public constructor() {}
}
